// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productSelectorStyles } from "@bg/Overrides/Components/ProductSelector";
import { productQuantityOrderedStyles } from "@bgs/Overrides/Components/ProductQuantityOrdered";
import { css } from "styled-components";

productSelectorStyles.productQuantityOrdered = {
    wrapper: {
        css: css`
            ${productQuantityOrderedStyles.wrapper?.css}
            border-right-width: 2px;
            margin-top: 3px;
            &&&& input {
                height: 28px !important;
            }
            && button {
                min-height: 28px;
            }
        `,
    },
};
